/*! @polar-analytics/pixel-sdk v0.18.0 — build IIFE vendored (NO editar a mano).
 *  Origen: https://unpkg.com/@polar-analytics/pixel-sdk@0.18.0/dist/index.global.js
 *  Actualizar = re-descargar la version pinneada. Expone el global `polarPixel`. */
"use strict";
var polarPixel = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // src/index.ts
  var src_exports = {};
  __export(src_exports, {
    POLAR_ATTR_KEY: () => POLAR_ATTR_KEY,
    eventFactory: () => eventFactory,
    generateCartAttribute: () => generateCartAttribute,
    generatePayloadBase: () => generatePayloadBase,
    generateUniqueId: () => generateUniqueId,
    sendPixelEvent: () => sendPixelEvent
  });

  // src/eventFactory.ts
  var EVENT_TYPES = {
    product_viewed: "product_viewed",
    collection_viewed: "collection_viewed",
    checkout_completed: "checkout_completed",
    page_viewed: "page_viewed",
    cart_viewed: "cart_viewed",
    checkout_address_info_submitted: "checkout_address_info_submitted",
    checkout_contact_info_submitted: "checkout_contact_info_submitted",
    checkout_shipping_info_submitted: "checkout_shipping_info_submitted",
    checkout_started: "checkout_started",
    payment_info_submitted: "payment_info_submitted",
    product_added_to_cart: "product_added_to_cart",
    product_removed_from_cart: "product_removed_from_cart",
    product_variant_viewed: "product_variant_viewed",
    search_submitted: "search_submitted",
    custom: "custom"
  };
  var eventFactory = Object.fromEntries(
    Object.keys(EVENT_TYPES).map((key) => [
      key,
      (v) => ({
        ...v,
        shopifyEventName: key === "custom" ? v == null ? void 0 : v.shopifyEventName : key
      })
    ])
  );

  // src/utilsMethods.ts
  var utils = {
    generateUniqueId: function() {
      if (typeof crypto === "object" && "randomUUID" in crypto) {
        return crypto.randomUUID();
      }
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!&$./";
      var charactersLength = characters.length;
      for (var i = 0; i < 24; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result.split("").sort(function() {
        return 0.5 - Math.random();
      }).join("");
    }
  };
  var appendAttributeToPayload = (payloadBase, attribute, getAttribute) => {
    const debugMode = 1;
    try {
      const data = getAttribute();
      payloadBase.data[attribute] = data;
    } catch (e) {
      if (debugMode) {
        console.log(e);
      }
      payloadBase.errors.push(JSON.stringify(e.stack));
    }
  };

  // src/storageMethods.ts
  var checkForUniqueUserId = async (storage) => {
    const localStorageStringAppend = "pap";
    const existingId = await storage.getItem(
      localStorageStringAppend + "_unique_user_id"
    );
    if (!existingId) {
      var newId = utils.generateUniqueId();
      storage.setItem(localStorageStringAppend + "_unique_user_id", newId);
      return newId;
    }
    return existingId;
  };
  var checkForSessionId = async function(storage) {
    const tabId = await storage.getItem("tabId");
    if (!tabId) {
      const newId = utils.generateUniqueId();
      storage.setItem("tabId", newId);
      return newId;
    }
    return tabId;
  };
  var storageMethods = {
    appendStorageTagging: async function(storage, payloadBase) {
      try {
        payloadBase.data["userId"] = await checkForUniqueUserId(storage);
        payloadBase.data["sessionId"] = await checkForSessionId(storage);
      } catch (e) {
        console.log(e);
        payloadBase.errors.push(JSON.stringify(e.stack));
      }
    }
  };

  // src/windowMethods.ts
  var windowMethods = {
    getPageQuery: function(document2) {
      return document2.location.search != "" ? document2.location.search : null;
    },
    getReferrer: function(document2) {
      return document2.referrer != "" ? document2.referrer : null;
    },
    getPagePath: function(document2) {
      return document2.location.pathname;
    },
    getPageTitle: function(document2) {
      return document2.title;
    },
    getPageHost: function(document2) {
      return document2.location.origin;
    },
    getPageUrlNoQuery: function(document2) {
      return document2.location.origin + document2.location.pathname;
    },
    appendWindowAttributes: (document2, payloadBase) => {
      appendAttributeToPayload(
        payloadBase,
        "pageQuery",
        () => {
          var _a;
          return (_a = windowMethods.getPageQuery(document2)) != null ? _a : void 0;
        }
      );
      appendAttributeToPayload(
        payloadBase,
        "pageReferrer",
        () => {
          var _a;
          return (_a = windowMethods.getReferrer(document2)) != null ? _a : void 0;
        }
      );
      appendAttributeToPayload(
        payloadBase,
        "pageOrigin",
        () => windowMethods.getPageHost(document2)
      );
      appendAttributeToPayload(
        payloadBase,
        "pagePath",
        () => windowMethods.getPagePath(document2)
      );
      appendAttributeToPayload(
        payloadBase,
        "pageTitle",
        () => windowMethods.getPageTitle(document2)
      );
    }
  };

  // src/utmMethods.ts
  var utmMethods = {
    getSource: function(document2) {
      var _a, _b;
      var firstSplit = (_b = (_a = windowMethods.getPageQuery(document2)) == null ? void 0 : _a.split("source=")) != null ? _b : [];
      if (firstSplit.length < 2) {
        return null;
      }
      return firstSplit[1].split("&")[0];
    },
    getCampaign: function(document2) {
      var _a, _b;
      var firstSplit = (_b = (_a = windowMethods.getPageQuery(document2)) == null ? void 0 : _a.split("campaign=")) != null ? _b : [];
      if (firstSplit.length < 2) {
        return null;
      }
      return firstSplit[1].split("&")[0];
    },
    getMedium: function(document2) {
      var _a, _b;
      var firstSplit = (_b = (_a = windowMethods.getPageQuery(document2)) == null ? void 0 : _a.split("medium=")) != null ? _b : [];
      if (firstSplit.length < 2) {
        return null;
      }
      return firstSplit[1].split("&")[0];
    },
    getContent: function(document2) {
      var _a, _b;
      var firstSplit = (_b = (_a = windowMethods.getPageQuery(document2)) == null ? void 0 : _a.split("content=")) != null ? _b : [];
      if (firstSplit.length < 2) {
        return null;
      }
      return firstSplit[1].split("&")[0];
    },
    getTerm: function(document2) {
      var _a, _b;
      var firstSplit = (_b = (_a = windowMethods.getPageQuery(document2)) == null ? void 0 : _a.split("term=")) != null ? _b : [];
      if (firstSplit.length < 2) {
        return null;
      }
      return firstSplit[1].split("&")[0];
    },
    appendAllUtmParameters: function(document2, payloadBase) {
      if (windowMethods.getPageQuery(document2)) {
        appendAttributeToPayload(
          payloadBase,
          "utmSource",
          () => {
            var _a;
            return (_a = this.getSource(document2)) != null ? _a : void 0;
          }
        );
        appendAttributeToPayload(
          payloadBase,
          "utmCampaign",
          () => {
            var _a;
            return (_a = this.getCampaign(document2)) != null ? _a : void 0;
          }
        );
        appendAttributeToPayload(
          payloadBase,
          "utmMedium",
          () => {
            var _a;
            return (_a = this.getMedium(document2)) != null ? _a : void 0;
          }
        );
        appendAttributeToPayload(
          payloadBase,
          "utmContent",
          () => {
            var _a;
            return (_a = this.getContent(document2)) != null ? _a : void 0;
          }
        );
        appendAttributeToPayload(
          payloadBase,
          "utmTerm",
          () => {
            var _a;
            return (_a = this.getTerm(document2)) != null ? _a : void 0;
          }
        );
      }
    }
  };

  // src/cookie.ts
  var listOfCookies = {
    AWIN_CHANNEL_COOKIE: "AwinChannelCookie",
    BING_SID: "_uetsid",
    BING_VID: "_uetvid",
    CRITEO_USER_ID: "crto_mapped_user_id",
    CRITEO_USER_OPT_OUT: "crto_is_user_optout",
    FACEBOOK_BROWSER_ID: "_fbp",
    FACEBOOK_CLICK_ID: "_fbc",
    GOOGLE_ANALYTICS: "_ga",
    GOOGLE_ANALYTICS_GA4_PREFIX: "_ga_",
    REDDIT_UUID: "_rdt_uuid",
    RTB_UID: "__rtb_e",
    SNAPCHAT_USER_ID: "_scid",
    TIKTOK_CLICK_ID: "ttclid",
    TIKTOK_COOKIE_ID: "_ttp",
    GOOGLE_CLICK_ID: "gclid",
    GOOGLE_GBRAID: "gbraid",
    GOOGLE_WBRAID: "wbraid",
    GOOGLE_GC_AW: "_gcl_aw",
    UTM_CAMPAIGN: "utm_campaign",
    UTM_CONTENT: "utm_content",
    UTM_MEDIUM: "utm_medium",
    UTM_SOURCE: "utm_source",
    UTM_TERM: "utm_term",
    AWIN: "awc",
    BING: "msclkid",
    CJ: "cjevent",
    FACEBOOK: "fbclid",
    GOOGLE_ADS: "gclsrc",
    IMPACT_RADIUS: "irclickid",
    ITERABLE: "iterable_campaign",
    KLAVIYO: "_kx",
    OUTBRAIN: "dicbo",
    PARTNERIZE: "clickref",
    PEPPERJAM: "clickId",
    PEPPERJAM_PUBLISHER_ID: "ev_publisherId",
    PINTEREST: "epik",
    RAKUTEN: "ranSiteID",
    REDDIT: "rdt_cid",
    SHAREASALE: "sscid",
    SNAPCHAT: "ScCid",
    TABOOLA: "tblci",
    TIKTOK: "ttclid",
    TWITTER: "twclid",
    VOLUUM: "vlmcid"
  };
  var keysToTrack = new Set(Object.values(listOfCookies));
  var getMarketingCookie = (cookie, targetSet) => {
    if (!cookie) return {};
    const value = `; ${cookie}`;
    return value.split(";").reduce((acc, curr) => {
      if (curr === "") return acc;
      const [key, value2] = curr.split("=");
      const trimmedKey = key.trim();
      if (targetSet.has(trimmedKey)) {
        acc[trimmedKey] = value2;
      }
      return acc;
    }, {});
  };

  // src/generatePayloadBase.ts
  var generatePayloadBase = async ({
    timestamp,
    customer,
    isHeadless = true,
    ...dependencies
    // Prevent name clashes with builtins
  }) => {
    let payloadBase = {
      timestamp: timestamp || Date.now(),
      errors: [],
      data: {}
    };
    await storageMethods.appendStorageTagging(
      (dependencies == null ? void 0 : dependencies.storage) || localStorage,
      payloadBase
    );
    windowMethods.appendWindowAttributes(
      (dependencies == null ? void 0 : dependencies.document) || window.document,
      payloadBase
    );
    utmMethods.appendAllUtmParameters(
      (dependencies == null ? void 0 : dependencies.document) || window.document,
      payloadBase
    );
    if (isHeadless) {
      appendAttributeToPayload(payloadBase, "headlessEmail", () => "{{email}}");
    }
    appendAttributeToPayload(
      payloadBase,
      "shopifyOrderCustomerLocale",
      () => {
        var _a, _b;
        return (_b = (_a = dependencies.navigator || navigator) == null ? void 0 : _a.language) != null ? _b : void 0;
      }
    );
    appendAttributeToPayload(
      payloadBase,
      "userAgent",
      () => {
        var _a, _b;
        return (_b = (_a = dependencies.navigator || navigator) == null ? void 0 : _a.userAgent) != null ? _b : void 0;
      }
    );
    appendAttributeToPayload(
      payloadBase,
      "orderCustomerId",
      () => (customer == null ? void 0 : customer.id) || void 0
    );
    appendAttributeToPayload(
      payloadBase,
      "shopifyCustomerEmail",
      () => {
        var _a;
        return ((_a = customer == null ? void 0 : customer.email) == null ? void 0 : _a.toLowerCase()) || void 0;
      }
    );
    appendAttributeToPayload(
      payloadBase,
      "customerPrivacy",
      () => dependencies == null ? void 0 : dependencies.customerPrivacy
    );
    appendAttributeToPayload(
      payloadBase,
      "marketingCookie",
      () => getMarketingCookie(dependencies == null ? void 0 : dependencies.cookie, keysToTrack)
    );
    appendAttributeToPayload(
      payloadBase,
      "settings",
      () => dependencies == null ? void 0 : dependencies.settings
    );
    return payloadBase;
  };

  // src/sendPixelEvent.ts
  var DEFAULT_MAX_RETRIES = 3;
  var DEFAULT_BASE_DELAY_MS = 1e3;
  var sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  var isRetryableError = (error) => {
    if (error instanceof TypeError) {
      return true;
    }
    if (error instanceof DOMException && error.name === "AbortError") {
      return false;
    }
    return true;
  };
  var buildPayload = (payloadBase, eventPayload) => {
    var _a;
    return {
      errors: [...payloadBase.errors || [], ...(eventPayload == null ? void 0 : eventPayload.errors) || []],
      timestamp: payloadBase.timestamp,
      ...payloadBase.data,
      ...eventPayload == null ? void 0 : eventPayload.data,
      shopifyClientId: ((_a = eventPayload == null ? void 0 : eventPayload.data) == null ? void 0 : _a.shopifyClientId) || payloadBase.data.user_id
    };
  };
  var sendWithBeacon = (endpoint, payload) => {
    if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") {
      return false;
    }
    try {
      const blob = new Blob([JSON.stringify(payload)], {
        type: "application/json"
      });
      return navigator.sendBeacon(endpoint, blob);
    } catch {
      return false;
    }
  };
  var sendWithFetch = async (endpoint, payload, signal) => {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      keepalive: true,
      body: JSON.stringify(payload),
      signal
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return response;
  };
  var sendPixelEvent = async (endpoint, payloadBase, eventPayload, options) => {
    var _a, _b, _c, _d, _e, _f;
    const maxRetries = (_a = options == null ? void 0 : options.maxRetries) != null ? _a : DEFAULT_MAX_RETRIES;
    const baseDelayMs = (_b = options == null ? void 0 : options.baseDelayMs) != null ? _b : DEFAULT_BASE_DELAY_MS;
    const useBeacon = (_c = options == null ? void 0 : options.useBeacon) != null ? _c : false;
    const payload = buildPayload(payloadBase, eventPayload);
    if (typeof process !== "undefined" && process.env.DEBUG === "true") {
      console.log("[pixel-sdk] Sending event:", payload);
    }
    if (useBeacon) {
      const beaconSent = sendWithBeacon(endpoint, payload);
      if (beaconSent) {
        return { success: true, attempts: 1, usedBeacon: true };
      }
    }
    let lastError;
    let attempts = 0;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      attempts = attempt + 1;
      if (attempt > 0) {
        const delayMs = baseDelayMs * Math.pow(2, attempt - 1);
        if (typeof process !== "undefined" && process.env.DEBUG === "true") {
          console.log(
            `[pixel-sdk] Retry attempt ${attempt}, waiting ${delayMs}ms`
          );
        }
        (_d = options == null ? void 0 : options.onRetry) == null ? void 0 : _d.call(options, attempt, lastError, delayMs);
        await sleep(delayMs);
      }
      try {
        const response = await sendWithFetch(endpoint, payload, options == null ? void 0 : options.signal);
        (_e = options == null ? void 0 : options.onSuccess) == null ? void 0 : _e.call(options, response);
        return { success: true, attempts };
      } catch (e) {
        lastError = e instanceof Error ? e : new Error(String(e));
        if (typeof process !== "undefined" && process.env.DEBUG === "true") {
          console.log(
            `[pixel-sdk] Attempt ${attempts} failed:`,
            lastError.message
          );
        }
        if (!isRetryableError(e)) {
          break;
        }
      }
    }
    if (typeof process !== "undefined" && process.env.DEBUG === "true") {
      console.log(
        `[pixel-sdk] All ${attempts} attempts failed:`,
        lastError == null ? void 0 : lastError.message
      );
    }
    if (lastError) {
      (_f = options == null ? void 0 : options.onError) == null ? void 0 : _f.call(options, lastError, attempts);
    }
    return {
      success: false,
      attempts,
      error: lastError
    };
  };

  // src/generateCartAttribute.ts
  var POLAR_ATTR_KEY = "polar_attr";
  var SESSION_KEYS = /* @__PURE__ */ new Set([
    "sessionId",
    "userAgent"
  ]);
  var getUrlParam = (doc, param) => {
    var _a;
    const search = doc.location.search;
    if (!search) return void 0;
    const params = new URLSearchParams(search);
    return (_a = params.get(param)) != null ? _a : void 0;
  };
  var getCookieValue = (cookieStr, name) => {
    const result = getMarketingCookie(cookieStr, /* @__PURE__ */ new Set([name]));
    return result[name] || void 0;
  };
  var generateCartAttribute = async (args = {}) => {
    var _a, _b, _c, _d;
    const storage = (_a = args.storage) != null ? _a : localStorage;
    const doc = (_b = args.document) != null ? _b : document;
    const nav = (_c = args.navigator) != null ? _c : navigator;
    const cookieStr = (_d = args.cookie) != null ? _d : "cookie" in doc ? doc.cookie : "";
    let userId = await storage.getItem("pap_unique_user_id");
    if (!userId) {
      userId = utils.generateUniqueId();
      await storage.setItem("pap_unique_user_id", userId);
    }
    let sessionId = await storage.getItem("tabId");
    if (!sessionId) {
      sessionId = utils.generateUniqueId();
      await storage.setItem("tabId", sessionId);
    }
    let gclid = getUrlParam(doc, "gclid");
    if (!gclid) {
      const gclAw = getCookieValue(cookieStr, "_gcl_aw");
      if (gclAw) {
        const parts = gclAw.split(".");
        gclid = parts[parts.length - 1];
      }
    }
    const fbp = getCookieValue(cookieStr, "_fbp");
    let ttclid = getUrlParam(doc, "ttclid");
    if (!ttclid) {
      ttclid = getCookieValue(cookieStr, "_ttp");
    }
    const userAgent = nav.userAgent || void 0;
    const data = {
      userId,
      sessionId,
      gclid,
      fbp,
      ttclid,
      userAgent
    };
    if (args.existingPolarAttr) {
      try {
        const existing = JSON.parse(
          atob(args.existingPolarAttr)
        );
        for (const key of Object.keys(existing)) {
          if (SESSION_KEYS.has(key)) continue;
          if (existing[key] !== void 0 && existing[key] !== null && existing[key] !== "") {
            data[key] = existing[key];
          }
        }
      } catch {
      }
    }
    const filtered = Object.fromEntries(
      Object.entries(data).filter(([, v]) => v !== void 0 && v !== "")
    );
    const encoded = btoa(JSON.stringify(filtered));
    return { encoded, data };
  };

  // src/index.ts
  var generateUniqueId = utils.generateUniqueId;
  return __toCommonJS(src_exports);
})();
